import useLanguage from "../i18n/useLanguage";
import React from "react";
import { FaInstagram, FaTiktok } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t, href, basePath } = useLanguage();
  const isHomePage = basePath === "/";

  return (
    <footer className="bg-black text-white relative w-full">
      {/* gradient background */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, rgba(72, 72, 72, 0.35) -6.36%, rgba(0, 0, 0, 0.00) 109.49%)",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* LOGO + SOSMED + COPYRIGHT (CENTER) */}
          <div className="flex flex-col items-center text-center gap-6">
            <Link to={href("/")}>
              <img
                src="/images/logo/logo1.webp"
                alt={t("Logo Titik Senyap Studio - Studio kreatif dan pengembangan digital")}
                className="h-32 w-auto"
              />
            </Link>

            <div className="flex gap-4 justify-center">
              <a
                href="https://www.instagram.com/titiksenyapstudio"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-300 transition-colors"
                aria-label="Instagram"
              >
                <FaInstagram size={22} />
              </a>
              <a
                href="https://www.tiktok.com/@titiksenyapstudio"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-gray-300 transition-colors"
                aria-label="TikTok"
              >
                <FaTiktok size={22} />
              </a>
            </div>

            <p className="text-sm font-normal text-gray-400">
              ©2026 Titik Senyap Studio. <br />{t("All rights reserved.")}{" "}</p>
          </div>

          {/* SERVICES */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t("Our Services")}</h3>
            <ul className="space-y-4 font-normal text-gray-300">
              <li>{t("Product Designs & UI/UX")}</li>
              <li>{t("Website Development")}</li>
              <li>{t("Mobile Applications")}</li>
              <li>{t("Roblox Game Development")}</li>
              <li>{t("Augmented Reality (AR)")}</li>
              <li><Link to={href("/ai-photo-video")} className="hover:text-amber-300">{t("Jasa Foto & Video AI")}</Link></li>
            </ul>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t("Quick Links")}</h3>
            <ul className="space-y-4 font-normal">
              <li>
                <a
                  href={href(isHomePage ? "#hero" : "/#hero")}
                  className="hover:text-gray-300"
                >{t("Home")}{" "}</a>
              </li>
              <li>
                <a
                  href={href(isHomePage ? "#about" : "/#about")}
                  className="hover:text-gray-300"
                >{t("About")}{" "}</a>
              </li>
              <li>
                <a
                  href={href(isHomePage ? "#services" : "/#services")}
                  className="hover:text-gray-300"
                >{t("Services")}{" "}</a>
              </li>
              <li>
                <a href={href(isHomePage ? "#products" : "/#products")} className="hover:text-gray-300">{t("Products")}</a>
              </li>
              <li>
                <Link to={href("/catalog")} className="hover:text-gray-300">{t("Catalog")}{" "}</Link>
              </li>
              <li>
                <a
                  href={href(isHomePage ? "#portfolio" : "/#portfolio")}
                  className="hover:text-gray-300"
                >{t("Portfolio")}{" "}</a>
              </li>
              <li>
                <a
                  href={href(isHomePage ? "#contact" : "/#contact")}
                  className="hover:text-gray-300"
                >{t("Contact Us")}{" "}</a>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h3 className="text-lg font-semibold mb-6">{t("Contact Us")}</h3>
            <div className="space-y-4 font-normal text-gray-300">
              <p>{t("Phone:")}{" "}
                <a
                  href="https://wa.me/62881011844173"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  0881011844173
                </a>
              </p>
              <p>Email: titiksenyapstudio@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
